import news from './modules/news'
import home from './modules/home'
import product from './modules/product'
import investorRelations from './modules/investorRelations'
import about from './modules/about'
import manpowerResource from './modules/manpowerResource'
let api = {
    news:news,
    home:home,
    product:product,
    investorRelations:investorRelations,
    about:about,
    manpowerResource:manpowerResource
};

if (process.env.VUE_APP_CURRENTMODE === 'mock') {
    api = require('../../mock/mock').default
}

export default api
